import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type InventoryOutboxEventCountsResult = QueryAtomResult<
  typeof inventoryOutboxEventCountsQueryAtom
>;

export const inventoryOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.inventoryOutboxEventCounts',
  () => ({
    inventoryOutboxEventCounts: {
      item: true,
      category: true,
      itemGroup: true,
      inventoryTag: true,
    },
  }),
  {
    select: ({ inventoryOutboxEventCounts }) => inventoryOutboxEventCounts,
  },
);
